import { useEffect, useState } from 'react';
import { Box, CircularProgress, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
// Services
import { newPassword } from 'lib/api/login';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
// Assets
import PaystandLogo from 'assets/authentication/PSLogow.svg';
import './FormCreateNewPassword.css';

export const FormCreateNewPassword = () => {
    const qs = new URLSearchParams(window.location.search);
    const valueQs = qs.get('value');
    const emailToReset = qs.get('email');
    const history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const [inputs, setInputs] = useState({
        password: '',
        validatePassword: '',
        code: valueQs,
        email: emailToReset
    });
    const [submit, setSubmit] = useState(false);

    useEffect(() => {
        if (submit) {
            if (!password) return;
            const sendNewPassword = async () => {
                const response = await newPassword({ password, code, email });
                if (response.success) {
                    setSubmit(false);
                    setInputs({
                        password: '',
                        code: '',
                        email: '',
                        validatePassword: ''
                    });
                }
                history.push(APP_ROUTES.LOGIN);
            };
            sendNewPassword();
        }
    });

    const handleChange = event => {
        setInputs({
            ...inputs,
            [event.target.name]: event.target.value
        });
    };

    const { password, validatePassword, code, email } = inputs;
    return (
        <Box id="create-new-password-section">
            <Box>
                <Box display="flex" justifyContent="center">
                    <img className="paystand-logo" src={PaystandLogo} alt="paystand-logo" />
                </Box>
                <Box className="create-new-password-card">
                    <Box>
                        <label className="welcome-back">Add new Password</label>
                    </Box>
                    <Box className="gray-text" marginTop="0.5em">
                        Choose your new password to recover your account.
                    </Box>
                    <Box marginTop="32px">
                        <OutlinedInput
                            name="password"
                            className="input-login-form"
                            value={password}
                            placeholder="New Password"
                            onChange={handleChange}
                            required
                            tabIndex={0}
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        tabIndex={2}
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end">
                                        {!showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Box>
                    <Box marginTop="1em">
                        <OutlinedInput
                            name="validatePassword"
                            className="input-login-form"
                            value={validatePassword}
                            placeholder="Re-enter New Password"
                            onChange={handleChange}
                            required
                            tabIndex={1}
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        tabIndex={2}
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end">
                                        {!showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Box>
                    <Box marginTop="1.6em" height="3em">
                        {submit ? (
                            <CircularProgress />
                        ) : (
                            <button
                                type="button"
                                className={
                                    validatePassword !== password || password.length <= 7
                                        ? ['btn-submit', 'btn-disabled'].join(' ')
                                        : ['btn-submit', 'btn-active'].join(' ')
                                }
                                disabled={validatePassword !== password || password.length <= 7}
                                onClick={() => setSubmit(true)}>
                                Set new password
                            </button>
                        )}
                    </Box>
                    <Box className="copy-right-message gray-text">© Paystand, Inc, 2020. All Rights Reserved.</Box>
                </Box>
            </Box>
        </Box>
    );
};
